'use client'
/* eslint-disable react/jsx-no-literals */
import React from 'react'
import {
  SkeletonWrp,
  Card,
  StyledSimerItem,
  ProductCollectionSkeletonWrp,
  LayoutDataWrp,
  ProductDetailSkeleton,
  CartPageSkeleton,
  WishListSkeleton,
  RightContainerSkeleton,
} from './style'

const SkeletonCard = () => (
  <Card>
    <StyledSimerItem margin="0px 0px 1.5rem 0px" />
    <StyledSimerItem text margin="0px 0px 1rem 0px" />
    <StyledSimerItem text />
  </Card>
)

export default function LayoutSkelaton({ layoutName }) {
  const getLayout = (name) => {
    switch (name) {
      case 'ImageCarousel':
        return (
          <SkeletonWrp height="40rem">
            <StyledSimerItem />
          </SkeletonWrp>
        )
      case 'BrandCollection':
        return (
          <SkeletonWrp>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </SkeletonWrp>
        )
      case 'CategoryCollection':
        return (
          <SkeletonWrp>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </SkeletonWrp>
        )
      case 'VideoCardCarousel':
        return (
          <SkeletonWrp height="30rem">
            <StyledSimerItem />
          </SkeletonWrp>
        )
      case 'Image':
        return (
          <SkeletonWrp>
            <StyledSimerItem />
          </SkeletonWrp>
        )
      case 'Accordian':
        return (
          <SkeletonWrp height="20rem">
            <StyledSimerItem />
          </SkeletonWrp>
        )

      case 'ImageWithText':
        return (
          <SkeletonWrp height="45rem">
            <StyledSimerItem />
          </SkeletonWrp>
        )

      case 'CartPage':
        return (
          <CartPageSkeleton>
            <StyledSimerItem margin="0px 1rem 0px 0px" />
            <StyledSimerItem />
            <StyledSimerItem />
            <StyledSimerItem />
          </CartPageSkeleton>
        )

      case 'ProductCollection': {
        const height = {
          aboveDesktop: '45rem',
          belowTablet: '36rem',
          belowMobileL: '31rem',
        }
        return (
          <ProductCollectionSkeletonWrp height={height}>
            <StyledSimerItem margin="0px 1rem 0px 0px" />
            <StyledSimerItem margin="0px 1rem 0px 0px" />
            <StyledSimerItem margin="0px 1rem 0px 0px" />
            <StyledSimerItem margin="0px 1rem 0px 0px" />
          </ProductCollectionSkeletonWrp>
        )
      }

      case 'OrderAnnouncementBar':
        return <StyledSimerItem height="1rem" />

      case 'ProductDetail':
        return (
          <ProductDetailSkeleton>
            <StyledSimerItem margin="0px 1rem 0px 0px" />
            <StyledSimerItem />
          </ProductDetailSkeleton>
        )

      case 'MyAccount':
        return (
          <LayoutDataWrp position="absolute" top="20rem" height="40rem">
            <StyledSimerItem />
          </LayoutDataWrp>
        )

      case 'Wishlist':
        return (
          <WishListSkeleton height="40rem">
            <StyledSimerItem />
            <StyledSimerItem />
            <StyledSimerItem />
          </WishListSkeleton>
        )

      case 'LayoutDataLoader':
        return (
          <LayoutDataWrp position="absolute" top="O" height="40rem">
            <StyledSimerItem />
          </LayoutDataWrp>
        )

      case 'RightContainer':
        return (
          <RightContainerSkeleton>
            <StyledSimerItem />
          </RightContainerSkeleton>
        )

      case 'SelectDeliveryService':
        return (
          <SkeletonWrp height="12rem" maxWidth="50rem">
            <StyledSimerItem />
          </SkeletonWrp>
        )
      default:
        return (
          <SkeletonWrp height="40rem">
            <StyledSimerItem />
          </SkeletonWrp>
        )
    }
  }
  return <>{getLayout(layoutName)}</>
}
